import {combineReducers} from 'redux'
import ChapterReducers from './chapter_list'
import ActiveChapter from './chapter_active'
import ActiveItem from './item_active'
import TestContent from './test_content'
import TestChecked from './test_checked'
import ActiveBlock from './active_block'
import windowReducer from './window_reducer';
import buttonClosed from './button';
import loaded from './loaded';
import allElements from './loaded_chapters'
import navigation from './navigation';
import chapterContent from './chapterContent';
import domainReducer from './domainReducer';
import approved from './approved';

const allReducers = combineReducers({
    chapters: ChapterReducers,
    active: ActiveChapter,
    active_item: ActiveItem,
    test_content: TestContent,
    test_checked: TestChecked,
    active_block: ActiveBlock,
    window: windowReducer,
    buttonClosed,
    loaded,
    allElements,
    navigation,
    chapterContent,
    domainReducer,
    approved,
});

export default allReducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js